import { render, staticRenderFns } from "./Wronglink.vue?vue&type=template&id=0e25e7c3&scoped=true&"
import script from "./Wronglink.vue?vue&type=script&lang=js&"
export * from "./Wronglink.vue?vue&type=script&lang=js&"
import style0 from "./Wronglink.vue?vue&type=style&index=0&id=0e25e7c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25e7c3",
  null
  
)

export default component.exports